import { useState } from "react";
import { connect } from "react-redux";
import { Collapse, Tooltip } from "@mui/material";
import toast from "react-hot-toast";
import SaveIcon from '@mui/icons-material/Save';

import usePrompt from "../../../hooks/usePrompt";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomButton from "../../../common/CustomButton";

import { TestPromptV2, UpdatePromptV2, } from "../../../redux/prompt/actions";
import { sanitizeAndParseJSON } from "../../../utils";

function PromptArea(props) {
    const { prompt, properties, setActivePrompt, prompts, setPrompts, activePrompt, results, setResults } = props;
    const { arrangePromptValues, arrangeOnboardingResults } = usePrompt();

    const [temporaryPrompt, setTemporaryPrompt] = useState("");
    const [temporaryPromptPreview, setTemporaryPromptPreview] = useState("");
    const [showPreview, setShowPreview] = useState(true)

    const arrangedResults = arrangeOnboardingResults(results);
    const promptPreview = properties ? arrangePromptValues(temporaryPrompt || prompt?.text, [
        ...properties,
        ...arrangedResults
    ]) : "";

    const handleResetProperties = () => {

    }

    const handlePromptSubmit = async () => {
        const toastID = toast.loading("Testing Prompt...");
        const res = await props.TestPromptV2(temporaryPromptPreview || promptPreview, {
            id: prompt?.id,
            systemPrompt: null,
        }, prompt?.response_format || "");

        console.log("handlePromptSubmit", res);
        if (res?.success) {
            toast.dismiss(toastID);
            let tempResults = [...results];
            try {
                console.log("prompt?.response_format == 'json' ? JSON.parse(res?.summary).data : res?.summary", prompt?.response_format == "json" ? JSON.parse(res?.summary).data : res?.summary);
                tempResults[activePrompt] = prompt?.response_format == "json" ? JSON.parse(res?.summary).data : res?.summary;
            } catch (error) {
                alert("error", error);
                tempResults[activePrompt] = sanitizeAndParseJSON(res?.summary).data;
            }
            console.log("tempResults", tempResults);
            setResults(tempResults);

            activePrompt < 2 && setActivePrompt(ap => ap + (activePrompt < prompts?.length - 1 ? 1 : 0));

        } else {
            toast.error("Failed to test prompt", {
                id: toastID,
            });
        }


        return res?.success;
    }

    const handleUpdatingPrompt = async () => {
        const toastID = toast.loading("Updating Prompt...");
        const res = await props.UpdatePromptV2(prompt?.id, {
            text: temporaryPrompt
        });
        if (res) {
            setPrompts(
                prompts.map((p) => {
                    if (p.id === prompt?.id) {
                        return {
                            ...p,
                            text: temporaryPrompt
                        }
                    }
                    return p;
                })
            )

            toast.success("Prompt Updated Successfully", {
                id: toastID,
            });
        } else {
            toast.error("Failed to Update Prompt", {
                id: toastID,
            });
        }
    }

    return (
        <div id="opp-prompt-area">
            <div id="opp-pa-header">
                <h6>{`Step ${activePrompt + 1} of ${prompts?.length || 0}`}</h6>
                <Tooltip title={`Save Step ${activePrompt + 1} Prompt`} onClick={handleUpdatingPrompt}>
                    <SaveIcon className={`${(temporaryPrompt && temporaryPrompt !== prompt?.text) && "active"}`} />
                </Tooltip>
            </div>
            {/* <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                setTemporaryPromptPreview(e.target.outerText);
            }}>
                {
                    promptPreview
                }
            </pre> */}
            <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                setTemporaryPrompt(e.target.outerText);
            }}>
                {
                    prompt?.text
                }
            </pre>

            <div id="opp-p-a-preview">
                <h6 onClick={() => { setShowPreview(!showPreview) }} className="clickable">{`${showPreview ? "Hide" : "Show"} Preview`}</h6>
                <Collapse in={showPreview} timeout="auto" unmountOnExit>
                    <pre className="prompt-pre">
                        {
                            promptPreview
                        }
                    </pre>
                </Collapse>
            </div>

            <div id="opp-p-a-actions">
                {/* <CustomActionButton isPrimary={false} size="small" action={async () => {
                    handleResetProperties();
                }}>
                    Reset
                </CustomActionButton> */}

                <CustomButton disabled={activePrompt == 0} isPrimary={false} size="small" onClick={() => {
                    setActivePrompt(ap => ap - 1);
                }}>
                    Back
                </CustomButton>

                <CustomButton disabled={activePrompt == prompts?.length - 1} isPrimary={false} size="small" onClick={() => {
                    setActivePrompt(ap => ap + 1);
                }}>
                    Next
                </CustomButton>

                <CustomActionButton size="small" action={handlePromptSubmit}>
                    Submit
                </CustomActionButton>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    TestPromptV2,
    UpdatePromptV2,
})(PromptArea);
